import * as Yup from "yup";

export const UpdateCartSchema = Yup.object().shape({
    number: Yup.string().required("Пожалуйста, укажите идентификатор корзины"),
    user_id: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .required("Пожалуйста, выберите пользователя"),
});
